import { render, staticRenderFns } from "./JsonExporter.vue?vue&type=template&id=1267176a&scoped=true"
import script from "./JsonExporter.vue?vue&type=script&lang=js"
export * from "./JsonExporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1267176a",
  null
  
)

export default component.exports